import CommunicationModal from "./communication-modal";

export default CommunicationModal;